import OrderServices from '@/services-ts/Point/OrderServices'
import PointCreditServices from '@/services-ts/Point/PointCreditServices'
import RewardServices from '@/services-ts/Point/RewardServices'

const PointAPI = (apiPoint: string) => {
  return {
    OrderServices: new OrderServices(apiPoint),
    PointCreditServices: new PointCreditServices(apiPoint),
    RewardServices: new RewardServices(apiPoint),
  }
}

export default PointAPI
